import React, { useEffect, useState } from "react";

import { BottomNav } from "../../../components/Nav/BottomNav";
import { Wallet } from "../../../components/Wallet";

import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  getLogUserRequest,
  getPlansRequest,
  getUserInvestmentsRequest,
  claimRewardRequest,
} from "../../../redux/action";
import { CircularProgress } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { Invest } from "../../../components/Cards/Invest";
import { BiTimeFive, BiTargetLock, BiRocket } from "react-icons/bi";
import CurrencyDisplay from "../../../components/Currency/CurrencyDisplay";

const Home = () => {
  const dispatch = useDispatch();

  const { history } = useHistory();

  const {
    getPlansError,
    getPlansLoading,
    user,
    isLoggedIn,
    plans,
    getLogUserError,
    token,
    getUserInvestmentsLoading,
    investments,
    getUserInvestmentsError,
  } = useSelector((state) => {
    const {
      success: { getPlans: getPlansSuccess, claimReward: claimRewardSuccess },
      errors: {
        getPlans: getPlansError,
        getUserInvestments: getUserInvestmentsError,
        getLogUser: getLogUserError,
        claimReward: claimRewardError,
      },
    } = state.ajaxStatuses;

    const { getUserInvestmentsLoading, getPlansLoading, getLogUserLoading } =
      state.loadingIndicator;

    const { user, token, isLoggedIn } = state.userData;

    const { investments } = state.investmentData;

    const { plans } = state.planData;

    return {
      getPlansSuccess,
      getPlansError,
      getPlansLoading,
      user,
      isLoggedIn,
      plans,
      getLogUserError,
      token,
      getLogUserLoading,
      getUserInvestmentsLoading,
      investments,
      getUserInvestmentsError,
      claimRewardSuccess, // Add this
      claimRewardError,
    };
  });

  useEffect(() => {
    if (!isLoggedIn) {
      history.push("/signin");
    }
  }, [isLoggedIn]);
  useEffect(() => {
    if (getPlansError) {
      toast.error(getPlansError, {
        duration: 3000,
      });
    }
  }, [getPlansError]);

  useEffect(() => {
    if (getLogUserError) {
      toast.error(getLogUserError, {
        duration: 3000,
      });
    }
  }, [getLogUserError]);

  useEffect(() => {
    dispatch(getPlansRequest());

    dispatch(getLogUserRequest(token));
  }, [getPlansRequest, getLogUserRequest]);

  useEffect(() => {
    dispatch(getUserInvestmentsRequest(user._id));
  }, [getUserInvestmentsRequest]);

  useEffect(() => {
    if (getUserInvestmentsError) {
      toast.error(getUserInvestmentsError, {
        duration: 3000,
      });
    }
  }, [getUserInvestmentsError]);

  useEffect(() => {
    if (user?._id && token) {
      // Attempt to claim reward
      dispatch(claimRewardRequest({ token }));
    }
  }, [user?._id, token, dispatch]);

  const [activeInvestment, setActiveInvestment] = useState(0);
  const [expectedReturn, setExpectedReturn] = useState(0);
  const [isWealthSectionExpanded, setIsWealthSectionExpanded] = useState(false);

  useEffect(() => {
    if (!getUserInvestmentsLoading) {
      let amountInvested = 0;
      let expectedInvested = 0;

      for (let i = 0; i < investments.length; i++) {
        if (investments[i].isActive) {
          amountInvested += investments[i].amount;
          expectedInvested += investments[i].expectedReturn;
        }
      }

      setActiveInvestment(amountInvested);
      setExpectedReturn(expectedInvested);
    }
  }, [getUserInvestmentsLoading]);

  const imgArray = ["/img/new/card/planone.jpeg", "/img/new/card/plantwo.jpeg"];

  const descriptionArray = [
    {
      title: "Essential Growth Plan",
      description:
        "Designed for individuals starting their investment journey or those seeking steady and consistent progress.",
      features: [
        "Accessible entry level",
        "Fixed 7-day investment cycle",
        "Suitable for building a stable weekly growth foundation",
      ],
    },
    {
      title: "Prestige Growth Plan",
      description:
        "Tailored for investors looking to expand their portfolio with higher capital allocation.",
      features: [
        "Higher investment range with increased growth potential",
        "Priority support and timely account assistance",
        "Options to reinvest and compound returns over successive cycles",
      ],
    },
  ];

  return (
    <div>
      <div className="container w-full mx-auto relative  overflow-y-scroll pb-8">
        <header className="w-full flex items-center justify-between pt-4  px-2 font-sans ">
          {/* --- Center: Logo & Brand Name --- */}
          <div className="flex items-center gap-2.5 flex-1 pl-2">
            {/* Circular Logo Placeholder */}
            <div className="w-11 h-11 rounded-full bg-white shadow-sm border border-gray-100 flex items-center justify-center overflow-hidden shrink-0">
              <img
                src="/img/new/logo/logo.png"
                alt="ATDP Logo"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Text Details */}
            <div className="flex flex-col justify-center">
              <h1 className="text-[#071330] font-semibold text-[14px] leading-[1.15] tracking-tight">
                Africa's Trusted
                <br />
                Digital Platform
              </h1>
              <p className="text-slate-500 text-[8.5px] font-medium mt-0.5 tracking-wide">
                Connecting • Empowering • Transforming Africa
              </p>
            </div>
          </div>

          {/* --- Right: Notifications & Profile --- */}
          <div className="flex items-center gap-4 shrink-0 pr-1">
            {/* User Avatar */}
            <button className="relative w-10 h-10 rounded-full bg-[#071330] flex items-center justify-center text-white font-bold text-[15px] shadow-md active:scale-95 transition-transform">
              {`${user?.firstName?.[0] ?? ""}${user?.lastName?.[0] ?? ""}`.toUpperCase() ||
                "?"}
              {/* Online Status Indicator */}
              <div className="absolute -bottom-0.5 -right-0.5 w-3.5 h-3.5 bg-[#10b981] rounded-full border-2 border-white"></div>
            </button>
          </div>
        </header>
        <div className="px-1 pt-4">
          <Wallet
            activeInvestment={activeInvestment}
            expectedReturn={expectedReturn}
            user={user}
            isHome={true}
            getUserInvestmentsLoading={getUserInvestmentsLoading}
            investments={investments}
          />

          <div className="w-full mt-6 font-sans">
            {/* Section Header */}
            <h3 className="text-[17px] font-semibold text-slate-900 mb-3 px-1">
              My Overview
            </h3>

            {/* Main Overview Container */}
            <div className="w-full bg-white rounded-[1.25rem] shadow-[0_4px_15px_rgb(0,0,0,0.03)] border border-gray-100 flex items-center py-5">
              {/* Left Side: Active Invested */}
              <div className="flex-1 flex items-center gap-3 px-4">
                <div className="w-12 h-12 bg-[#0642cc] rounded-[0.8rem] flex items-center justify-center text-white shrink-0 shadow-md shadow-blue-600/20">
                  {/* Wallet Icon */}
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"></path>
                    <path d="M3 5v14a2 2 0 0 0 2 2h16v-5"></path>
                    <path d="M18 12a2 2 0 0 0 0 4h4v-4Z"></path>
                  </svg>
                </div>
                <div>
                  <p className="text-[11px] text-slate-500 font-medium mb-0.5">
                    Active Invested
                  </p>
                  <p className="text-[15px] font-semibold text-slate-900 tracking-tight">
                    <CurrencyDisplay
                      usdAmount={activeInvestment}
                      showCurrency={true}
                    />
                  </p>
                </div>
              </div>

              {/* Vertical Divider */}
              <div className="w-px h-12 bg-gray-100 shrink-0"></div>

              {/* Right Side: Active Returns */}
              <div className="flex-1 flex items-center gap-3 px-4">
                <div className="w-12 h-12 bg-[#f0f4ff] rounded-full flex items-center justify-center text-[#1a4bdf] shrink-0">
                  {/* Trending Up Icon */}
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                    <polyline points="16 7 22 7 22 13"></polyline>
                  </svg>
                </div>
                <div>
                  <p className="text-[11px] text-slate-500 font-medium mb-0.5">
                    Active Returns
                  </p>
                  <p className="text-[15px] font-semibold text-slate-900 tracking-tight">
                    <CurrencyDisplay
                      usdAmount={expectedReturn}
                      showCurrency={true}
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative mt-6 group">
            {/* --- Main Card Container --- */}
            <div className="relative overflow-hidden rounded-[2rem] bg-white border border-blue-100 shadow-[0_8px_30px_-8px_rgba(115,66,255,0.15)] isolate">
              {/* Background Image with Overlay */}
              <div
                className="absolute inset-0 z-0 transition-transform duration-700 group-hover:scale-105"
                style={{
                  backgroundImage: 'url("/img/new/background/intro.svg")',
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-r from-white via-white/90 to-blue-50/40 backdrop-blur-[1px]"></div>
              </div>
            </div>
          </div>

          <div className=" mt-10">
            <div className="text-2xl font-semibold  font-body text-[#2D2D2D]">
              Get Started Investing
            </div>

            <div className="pt-4">
              {getPlansLoading ? (
                <div className="h-[20vh] flex items-center justify-center text-center">
                  <CircularProgress size={20} className="text-primary" />
                </div>
              ) : (
                <div className="grid grid-cols-2 gap-x-1">
                  {plans.map((plan, index) => (
                    <Invest
                      fromWallet={false}
                      plan={plan}
                      key={index}
                      img={imgArray[index]}
                      planDescription={descriptionArray[index]}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="relative mt-10 mb-32  group">
            {/* --- Decorative Background Glow --- */}
            <div className="absolute inset-0 bg-gradient-to-br from-blue-100/50 via-purple-100/30 to-blue-50/20 blur-2xl rounded-[2rem] -z-10 transform scale-95 group-hover:scale-100 transition-transform duration-700"></div>

            {/* --- Main Glass Card --- */}
            <div className="relative bg-white/60 backdrop-blur-xl border border-white/80 shadow-[0_8px_32px_0_rgba(31,38,135,0.05)] rounded-[2rem] p-6 md:p-8 overflow-hidden">
              {/* Top Shine Highlight */}
              <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-white to-transparent opacity-80"></div>

              <div className="max-w-4xl mx-auto">
                {/* Header */}
                <div className="text-center mb-8">
                  <h3 className="font-head text-xl md:text-2xl font-semibold text-slate-900">
                    Why Choose a{" "}
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#7342FF] to-blue-600">
                      Africa's Trusted Digital Platform Plan?
                    </span>
                  </h3>
                  <div className="h-1 w-12 bg-blue-600/20 rounded-full mx-auto mt-3"></div>
                </div>

                {/* Features Layout */}
                <div className="flex flex-col gap-6">
                  {/* Point 1: Consistency */}
                  <div className="flex gap-4 items-start p-4 rounded-2xl bg-white/50 border border-white/60 hover:bg-white/80 transition-colors shadow-sm">
                    <div className="shrink-0 w-10 h-10 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center border border-blue-100 shadow-sm">
                      <BiTimeFive size={20} />
                    </div>
                    <div>
                      <h4 className="font-head text-sm font-semibold text-slate-800 mb-1">
                        Structured 7-Day Cycles
                      </h4>
                      <p className="text-xs md:text-sm font-body text-slate-500 leading-relaxed">
                        Every plan operates on a consistent 7-day timeline. We
                        value clarity, so you know exactly when your investment
                        cycle begins and ends before you commit.
                      </p>
                    </div>
                  </div>

                  {/* Point 2: Structure */}
                  <div className="flex gap-4 items-start p-4 rounded-2xl bg-white/50 border border-white/60 hover:bg-white/80 transition-colors shadow-sm">
                    <div className="shrink-0 w-10 h-10 rounded-xl bg-purple-50 text-purple-600 flex items-center justify-center border border-purple-100 shadow-sm">
                      <BiTargetLock size={20} />
                    </div>
                    <div>
                      <h4 className="font-head text-sm font-semibold text-slate-800 mb-1">
                        Professionally Managed
                      </h4>
                      <p className="text-xs md:text-sm font-body text-slate-500 leading-relaxed">
                        Our process supports diverse financial goals. Whether
                        you are starting with a modest allocation or investing
                        at a higher level, our flexible options adapt to your
                        capacity.
                      </p>
                    </div>
                  </div>

                  {/* Point 3: Execution */}
                  <div className="flex gap-4 items-start p-4 rounded-2xl bg-white/50 border border-white/60 hover:bg-white/80 transition-colors shadow-sm">
                    <div className="shrink-0 w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center border border-emerald-100 shadow-sm">
                      <BiRocket size={20} />
                    </div>
                    <div>
                      <h4 className="font-head text-sm font-semibold text-slate-800 mb-1">
                        Immediate Execution
                      </h4>
                      <p className="text-xs md:text-sm font-body text-slate-500 leading-relaxed">
                        Efficiency is key. Once a plan is selected and funding
                        is completed, the investment cycle launches immediately
                        according to the stated terms.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className=" mx-auto w-full ">
        <BottomNav />
      </div>
    </div>
  );
};

export default Home;
